/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Enum from 'astro/enum/route';

import BuildingAttack from 'astro/config/route/building.attack';
import BuildingCreateList from 'astro/config/route/building.create.list';
import BuildingCreateType from 'astro/config/route/building.create.type';
import BuildingUpgrade from 'astro/config/route/building.upgrade';

import UnitAttack from 'astro/config/route/unit.attack';
import UnitCreateList from 'astro/config/route/unit.create.list';
import UnitCreateType from 'astro/config/route/unit.create.type';


let Config = {}


Config[Enum.BuildingAttack]      = BuildingAttack;
Config[Enum.BuildingCreateList]  = BuildingCreateList;
Config[Enum.BuildingCreateType]  = BuildingCreateType;
Config[Enum.BuildingUpgrade]     = BuildingUpgrade;

Config[Enum.UnitAttack]          = UnitAttack;
Config[Enum.UnitCreateList]      = UnitCreateList;
Config[Enum.UnitCreateType]      = UnitCreateType;


export default Config;
